import { Utils } from "@/plugins/utils";

export default {
	namespaced: true,
	state: {
		fv2: null,
		insert: false,
		update: false,
		loading: false
	},
	getters: {
	},
	mutations: {
		set(state, fv2){
			state.fv2 = fv2
			if (fv2)
				state.update = true
		},
		initForm(state){
			state.insert = false
			state.update = false
		}
	},
	actions: {
		async find(store){
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios.get("/Representative/CatalogParameters/Find")
			.then(response => {
				let fv2 = Utils.ValidateAxiosResponse(response.data);
				store.commit("set", fv2)
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
		save(store){
			if (store.state.update){
				store.dispatch("update")
				return
			}
			store.dispatch("insert")
		},
		async insert(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.post("/Representative/CatalogParameters/Insert", store.state.fv2 )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				store.dispatch("find")
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async update(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.put("/Representative/CatalogParameters/Update", store.state.fv2 )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				store.dispatch("find")
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async delete(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
			await this._vm.$axios.delete("/Representative/CatalogParameters/Delete")
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				store.dispatch("find")
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
	}
}